module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/products-events.json
// module id = 521
// module chunks = 73270488149913